import template from './pagination.html';
import '../pagination.scss';

/**
 * @ngdoc component
 * @name odsPagination
 * @description
 * The pagination component.
 */
export default {
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings
   * @type {Object}
   * @property {Number}   end              the page end point.
   * @property {Number}   start            the page start point.
   * @property {Number}   total            the total amount of entities.
   * @property {Boolean}  hasNext          if the next button should be displayed.
   * @property {Boolean}  hasPrevious      if the previous button should be displayed.
   * @property {Function} onNextClick      callback when the next button is clicked.
   * @property {Function} onPreviousClick  callback when the previous button is clicked.
   */
  bindings: {
    end: '@',
    start: '@',
    total: '@',
    hasNext: '<',
    hasPrevious: '<',
    onNextClick: '&',
    onPreviousClick: '&',
  },
};
